import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';

const features = [
  {
    icon: 'ri-book-open-line',
    title: '海量资源',
    description: '收录超过10000部韩漫、日漫、国漫作品，涵盖恋爱、奇幻、动作、搞笑等多种类型，满足不同读者的阅读口味。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端支持',
    description: '提供安卓APP与iOS手机版下载，支持下拉式在线阅读。无论是在手机、平板还是电脑上，都能享受流畅的漫画阅读体验。',
  },
  {
    icon: 'ri-download-line',
    title: '离线缓存',
    description: '支持漫画章节离线缓存功能，提前下载后无需网络也能随时随地畅享阅读，地铁通勤、旅行途中都不耽误追更。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    description: '严格的内容审核机制，确保所有漫画资源合规合法。APP经过严格安全检测，保护用户隐私和数据安全。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速更新',
    description: '每日同步更新热门漫画最新章节，追更提醒功能让你不错过任何更新。热门韩漫日漫与官方保持同步。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '优质服务',
    description: '7x24小时客服支持，用户反馈快速响应。持续优化阅读体验，致力于成为最受用户喜爱的漫画阅读平台。',
  },
];

const milestones = [
  { year: '2020', event: '亲亲漫画项目正式立项，团队组建完成', icon: 'ri-flag-line' },
  { year: '2021', event: '亲亲漫画APP安卓版首次发布上线', icon: 'ri-android-line' },
  { year: '2022', event: 'iOS版本上线，双平台用户突破100万', icon: 'ri-apple-line' },
  { year: '2023', event: '漫画资源突破5000部，日活用户超过50万', icon: 'ri-bar-chart-line' },
  { year: '2024', event: '推出下拉式阅读模式，用户体验全面升级', icon: 'ri-layout-masonry-line' },
  { year: '2025', event: '漫画资源突破10000部，累计下载量突破2000万', icon: 'ri-medal-line' },
  { year: '2026', event: '持续优化产品，引领免费漫画阅读新风尚', icon: 'ri-rocket-line' },
];

const testimonials = [
  {
    name: '小猫咪爱吃鱼',
    avatar: 'ri-user-3-line',
    rating: 5,
    content: '用了亲亲漫画一年多，资源真的很丰富！韩漫更新速度超快，画质也很清晰。下拉式阅读比翻页舒服多了，强烈推荐！',
    date: '2026-07-28',
  },
  {
    name: '追漫达人Leo',
    avatar: 'ri-user-4-line',
    rating: 5,
    content: '从其他平台转过来的，不得不说亲亲漫画的体验真的很棒。免费无广告弹窗，离线缓存功能在地铁上看太方便了。',
    date: '2026-07-25',
  },
  {
    name: '樱花下的约定',
    avatar: 'ri-user-5-line',
    rating: 5,
    content: '国漫和日漫的资源都很全，分类也很清晰，找漫画很方便。每天都有更新提醒，再也不会错过追更了。好评！',
    date: '2026-07-22',
  },
  {
    name: '热血少年阿杰',
    avatar: 'ri-user-6-line',
    rating: 4,
    content: '作为一个日漫迷，亲亲漫画上的日漫资源非常全面。从经典到新番都有，阅读界面也很干净清爽。希望继续保持更新速度。',
    date: '2026-07-20',
  },
  {
    name: '甜甜的恋爱脑',
    avatar: 'ri-user-2-line',
    rating: 5,
    content: '韩漫爱好者狂喜！各种恋爱、穿越、逆袭题材应有尽有。最重要的是完全免费，闺蜜也被我安利过来了。',
    date: '2026-07-18',
  },
  {
    name: '深夜追更人',
    avatar: 'ri-user-line',
    rating: 5,
    content: '亲亲漫画是我用过最好的免费漫画APP。界面简洁、加载速度快、资源丰富。离线缓存功能真的很实用，出差必备。',
    date: '2026-07-15',
  },
];

export default function AboutPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="pt-20">
        <section className="relative h-[320px] md:h-[400px] flex items-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=A%20warm%20and%20artistic%20abstract%20illustration%20with%20soft%20gradient%20in%20coral%20and%20cream%20tones%2C%20featuring%20subtle%20manga%20reading%20silhouettes%20and%20floating%20book%20pages%2C%20clean%20modern%20minimalist%20style%2C%20warm%20inviting%20atmosphere%2C%20professional%20corporate%20feel&width=1600&height=450&seq=about-hero-manga&orientation=landscape"
              alt="关于亲亲漫画"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-background-900/60 via-background-900/40 to-background-900/60"></div>
          </div>
          <div className="relative w-full px-4 md:px-6">
            <div className="max-w-[1400px] mx-auto text-center">
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 mb-4">关于亲亲漫画</h1>
              <p className="text-sm md:text-base text-background-50/70 max-w-2xl mx-auto leading-relaxed">
                致力于为漫画爱好者提供最优质的免费在线阅读体验
              </p>
            </div>
          </div>
        </section>

        <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
          <nav className="flex items-center gap-2 text-sm text-foreground-500 my-6" aria-label="面包屑导航">
            <Link to="/" className="hover:text-primary-500 transition-colors duration-200">首页</Link>
            <span>/</span>
            <span className="text-foreground-900 font-medium">关于我们</span>
          </nav>

          <section className="py-10 md:py-16">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-6 text-center">品牌介绍</h2>
              <div className="bg-background-100 rounded-2xl p-6 md:p-8">
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                  <strong className="text-foreground-900">亲亲漫画</strong>是一款专注于免费漫画在线阅读的移动应用平台。自2020年创立以来，我们始终秉持"让每个人都能免费享受漫画的乐趣"的初心，为广大漫画爱好者提供丰富的韩漫、日漫、国漫资源。
                </p>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                  亲亲漫画APP支持安卓与iOS双平台，采用创新的<strong className="text-foreground-900">下拉式阅读</strong>模式，让用户在手机上获得如丝般顺滑的阅读体验。同时支持离线缓存功能，即使在没有网络的环境下也能畅享漫画世界。
                </p>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                  我们的团队由一群热爱漫画的年轻人组成，深知漫画爱好者的需求和痛点。因此亲亲漫画始终坚持<strong className="text-foreground-900">完全免费、无广告干扰</strong>的原则，致力于打造最纯净、最舒适的漫画阅读环境。截至目前，亲亲漫画已累计服务超过<strong className="text-primary-500">500万</strong>用户，APP下载量突破<strong className="text-primary-500">2000万</strong>次。
                </p>
              </div>
            </div>
          </section>

          <section className="py-10 md:py-16 bg-background-100 -mx-4 md:-mx-6 px-4 md:px-6">
            <div className="max-w-[1400px] mx-auto">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-10 text-center">我们的优势</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {features.map((feature, i) => (
                  <div key={i} className="bg-background-50 rounded-xl p-6 hover:bg-background-50 transition-colors duration-200">
                    <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500 mb-4">
                      <i className={`${feature.icon} text-xl`}></i>
                    </div>
                    <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">{feature.title}</h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">{feature.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="py-10 md:py-16">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-10 text-center">发展历程</h2>
              <div className="relative">
                <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-0.5 bg-background-200 -translate-x-1/2 hidden md:block"></div>
                <div className="absolute left-4 top-0 bottom-0 w-0.5 bg-background-200 md:hidden"></div>
                <div className="space-y-8">
                  {milestones.map((item, i) => (
                    <div key={i} className={`relative flex items-start gap-6 ${i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
                      <div className={`hidden md:block flex-1 ${i % 2 === 0 ? 'text-right' : 'text-left'}`}>
                        <div className={i % 2 === 0 ? 'pr-10' : 'pl-10'}>
                          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500 text-background-50 text-sm font-heading font-bold">
                            {item.year}
                          </span>
                          <p className="text-sm text-foreground-600 mt-2">{item.event}</p>
                        </div>
                      </div>
                      <div className="absolute left-4 md:left-1/2 -translate-x-1/2 w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center z-10">
                        <i className={`${item.icon} text-sm text-background-50`}></i>
                      </div>
                      <div className="flex-1 md:hidden pl-12">
                        <span className="inline-block px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-heading font-bold">
                          {item.year}
                        </span>
                        <p className="text-sm text-foreground-600 mt-1.5">{item.event}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>

          <section className="py-10 md:py-16 bg-background-100 -mx-4 md:-mx-6 px-4 md:px-6">
            <div className="max-w-[1400px] mx-auto">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2 text-center">用户口碑</h2>
              <p className="text-sm text-foreground-500 text-center mb-10">来自真实用户的评价与反馈</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {testimonials.map((t, i) => (
                  <div key={i} className="bg-background-50 rounded-xl p-6">
                    <div className="flex items-center gap-3 mb-4">
                      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-500">
                        <i className={`${t.avatar} text-lg`}></i>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-foreground-900">{t.name}</p>
                        <p className="text-[11px] text-foreground-500">{t.date}</p>
                      </div>
                      <div className="ml-auto flex items-center gap-0.5">
                        {Array.from({ length: t.rating }).map((_, j) => (
                          <div key={j} className="w-4 h-4 flex items-center justify-center">
                            <i className="ri-star-fill text-amber-400 text-xs"></i>
                          </div>
                        ))}
                      </div>
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed">{t.content}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="py-10 md:py-16">
            <div className="max-w-2xl mx-auto text-center">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-6">联系我们</h2>
              <p className="text-sm text-foreground-600 mb-8 leading-relaxed">
                如果您有任何问题、建议或合作意向，欢迎通过以下方式联系我们。亲亲漫画团队将竭诚为您服务。
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                <div className="bg-background-100 rounded-xl p-5">
                  <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500">
                    <i className="ri-mail-line text-lg"></i>
                  </div>
                  <p className="text-xs text-foreground-500 mb-1">电子邮箱</p>
                  <p className="text-sm font-medium text-foreground-900">contact@qinqinmanga.com</p>
                </div>
                <div className="bg-background-100 rounded-xl p-5">
                  <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-lg bg-accent-100 text-accent-500">
                    <i className="ri-group-line text-lg"></i>
                  </div>
                  <p className="text-xs text-foreground-500 mb-1">官方QQ群</p>
                  <p className="text-sm font-medium text-foreground-900">874123569</p>
                </div>
                <div className="bg-background-100 rounded-xl p-5">
                  <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-500">
                    <i className="ri-smartphone-line text-lg"></i>
                  </div>
                  <p className="text-xs text-foreground-500 mb-1">APP下载</p>
                  <a href="/#download" className="text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors duration-200">
                    点击下载
                  </a>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
}